<div class="container">
    <div *ngFor="let doc of documentUrl">
        <h2>{{doc.documentName}}</h2>
                <img [src]="doc.frontSideURL" width="300px" height="300px" *ngIf="showFrontImg" (click)="uploadFromLoacl(doc.frontSide)" >
                <img [src]="doc.backSideURL" width="300px" height="300px" *ngIf ="showBackImg" (click)="uploadFromLoacl(doc.backSide)" >
    </div>

    <modal #previewImgModal>
        <modal-content>
            <iframe [src]="urlSafeEmbed" frameborder="0" width="600px" height="400px"></iframe>
            <button (click)="closePreviewImg()" class="btn btn-danger pull-right" type="button">{{'Cancel'}}</button>
        </modal-content>
    </modal>
</div>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/member-documents.component.html